/**
 * // TODO: Update this based on the Ecosystem values!
 * @typedef {{
 *     "company": string,
 *     "industry": string,
 *     "priorities": string,
 *     "multiChannel": string,
 *     "How many unique site visitors do you have annually?": string,
 *     "How many subscribers does your company have across all marketing channels?": string,
 *     "What is the annual send volume across all channels?": string,
 *     "What percent of your send volume is batch & blast campaigns?": string,
 *     "What is the annual marketing attributed revenue across channels considered?": string,
 *     "What is the average transaction value?": string,
 *     "What is the current annual churn rate of your customers?": string,
 *     "How many marketers are required to support your current campaign operations?": string,
 *     "How many engineering resources are required to support marketing?": string,
 *     "wvc_OutputURL": string | undefined,
 * }} CalculatorData
 */

/**
 * @typedef {{
 *     Company: string,
 *     wvc_Industry: string,
 *     wvc_MarketingChannelsinEvaluation: string,
 *     wvc_EvaluatingMultipleChannels: string,
 *     wvc_UniqueSiteVisitors: string,
 *     wvc_TotalMarketingSubscribers: string,
 *     wvc_AnnualSendVolume: string,
 *     wvc_TriggeredEventRate: string,
 *     wvc_AnnualMarketingRevenue: string,
 *     wvc_AverageOrderValue: string,
 *     wvc_AnnualChurnRate: string,
 *     wvc_TotalCampaignMarketers: string,
 *     wvc_TotalEngineeringMarketers: string,
 *     wvc_OutputURL: string | undefined,
 * }} MarketoCalculatorData
 */

/**
 * @param calculatorData {CalculatorData}
 * @return {MarketoCalculatorData}
 */
module.exports = function convertCalculatorDataToMarketoCalculatorData(calculatorData) {
    const marketoCalculatorData = {
        Company: calculatorData["company"],
        wvc_Industry: calculatorData["industry"],
        wvc_MarketingChannelsinEvaluation: calculatorData["priorities"],
        wvc_EvaluatingMultipleChannels: calculatorData["multiChannel"],
        wvc_UniqueSiteVisitors: calculatorData["How many unique site visitors do you have annually?"],
        wvc_TotalMarketingSubscribers: calculatorData["How many subscribers does your company have across all marketing channels?"],
        wvc_AnnualSendVolume: calculatorData["What is the annual send volume across all channels?"],
        wvc_TriggeredEventRate: calculatorData["What percent of your send volume is batch & blast campaigns?"],
        wvc_AnnualMarketingRevenue: calculatorData["What is the annual marketing attributed revenue across channels considered?"],
        wvc_AverageOrderValue: calculatorData["What is the average transaction value?"],
        wvc_AnnualChurnRate: calculatorData["What is the current annual churn rate of your customers?"],
        wvc_TotalCampaignMarketers: calculatorData["How many marketers are required to support your current campaign operations?"],
        wvc_TotalEngineeringMarketers: calculatorData["How many engineering resources are required to support marketing?"],
    };

    if ('wvc_OutputURL' in calculatorData) {
        marketoCalculatorData['wvc_OutputURL'] = calculatorData["wvc_OutputURL"];
    }

    return marketoCalculatorData;
}
